import {
  faArrowLeft,
  faAsterisk,
  faBan,
  faBell,
  faBook,
  faCalendarAlt,
  faCheck,
  faCloud,
  faCogs,
  faDatabase,
  faDownload,
  faEye,
  faFilter,
  faFlag,
  faHeart,
  faHome,
  faKey,
  faList,
  faLock,
  faPencilAlt,
  faPlus,
  faRoad,
  faSave,
  faSearch,
  faSignInAlt,
  faSignOutAlt,
  faSort,
  faSpinner,
  faSync,
  faTachometerAlt,
  faTasks,
  faThList,
  faTimes,
  faTimesCircle,
  faTrash,
  faUser,
  faUserPlus,
  faUsers,
  faUsersCog,
  faWallet,
  faWrench,
} from '@fortawesome/free-solid-svg-icons';

import { library } from '@fortawesome/fontawesome-svg-core';

export const loadIcons = () => {
  library.add(
    faArrowLeft,
    faAsterisk,
    faBan,
    faBell,
    faBook,
    faCalendarAlt,
    faCheck,
    faCloud,
    faCogs,
    faDatabase,
    faDownload,
    faEye,
    faFilter,
    faFlag,
    faHeart,
    faHome,
    faKey,
    faList,
    faLock,
    faPencilAlt,
    faPlus,
    faRoad,
    faSave,
    faSignInAlt,
    faSignOutAlt,
    faSearch,
    faSort,
    faSpinner,
    faSync,
    faTachometerAlt,
    faTasks,
    faThList,
    faTimes,
    faTimesCircle,
    faTrash,
    faUser,
    faUserPlus,
    faUsers,
    faUsersCog,
    faWallet,
    faWrench,
  );
};
